import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { CALENDLY_URL } from '../data/mock';

const HeroSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCalendlyClick = () => {
    if (CALENDLY_URL && CALENDLY_URL !== 'PLACEHOLDER_CALENDLY_URL') {
      window.open(CALENDLY_URL, '_blank', 'width=800,height=800');
    }
  };

  return (
    <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden pt-36">
      {/* Animated Background Blobs */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-blue-400/30 rounded-full blur-3xl animate-blob"></div>
        <div className="absolute top-40 right-20 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/3 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      {/* Static Background Image - Swiss Alps */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1521292270410-a8c4d716d518?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Schweizer Alpen"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/50 via-blue-800/40 to-blue-600/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-slide-up">
          Vertrauen, das bleibt!
        </h1>
        <p className="text-lg md:text-xl text-blue-50 mb-10 max-w-3xl mx-auto animate-slide-up animation-delay-200 leading-relaxed">
          Vivalo steht für moderne, transparente und unabhängige Beratung in der Schweizer Finanz- und Versicherungswelt. Wir begleiten Privatpersonen, Selbstständige und Unternehmen bei allen Themen rund um Vorsorge, Absicherung und Finanzstrategie. Unsere Beratung ist persönlich, kompetent und langfristig ausgerichtet.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up animation-delay-400">
          <Button
            onClick={handleCalendlyClick}
            size="lg"
            className="bg-white text-blue-700 hover:bg-blue-50 text-lg px-8 py-6 shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 hover:-translate-y-1"
          >
            Jetzt Beratung anfragen
            <ArrowRight className="ml-2" size={20} />
          </Button>
          <Button
            onClick={() => scrollToSection('services')}
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/20 backdrop-blur-sm text-lg px-8 py-6 shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            Unsere Leistungen
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;